import pancakeSwapAbi from "@app/lib/contract/abis/pancake.json";
import { BNBTokenAddress, PancakeSwapContractAddress, USDTokenAddress } from "@app/shared/AppConstant";
import { BigNumberish } from "@ethersproject/bignumber";
import { Contract } from "@ethersproject/contracts";
import { JsonRpcSigner } from "@ethersproject/providers";
import { formatUnits } from "@ethersproject/units";

interface GetPriceOptions {
  amount: BigNumberish;
  tokenAddress: string;
  decimals: number;
  signer: JsonRpcSigner;
}

interface GetPriceResult {
  token: string;
  bnb: string;
  usdt: string;
}

export async function getPrice({ amount, decimals, signer, tokenAddress }: GetPriceOptions): Promise<GetPriceResult> {
  try {
    const pancakeSwapContract = new Contract(PancakeSwapContractAddress, pancakeSwapAbi, signer);
    const amountOut = await pancakeSwapContract.getAmountsOut(amount, [tokenAddress, BNBTokenAddress]);
    const usdtAmountOut = await pancakeSwapContract.getAmountsOut(amountOut[1], [BNBTokenAddress, USDTokenAddress]);

    return {
      token: formatUnits(amount, decimals),
      bnb: formatUnits(amountOut[1]),
      usdt: formatUnits(usdtAmountOut[1]),
    };
  } catch (error) {
    console.log(error);
    return {
      token: "0",
      bnb: "0",
      usdt: "0",
    };
  }
}
